/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import { DocPropertiesComponent } from "./DocPropertiesComponent";
import DocumentPropertiesCss from "./DocumentProperties.css";

const Dialog = require("@react/react-spectrum/Dialog").default;

class DocumentPropertiesDialog extends Component {
  render() {
    const intl = this.props.intl;
    const formatMessage = intl.formatMessage;

    return (
      <Dialog
        title={formatMessage({
          id: "dialog.documentProperties.title"
        })}
        onConfirm={this.props.closeDialog}
        onClose={this.props.closeDialog}
        confirmLabel={formatMessage({ id: "common.ok" })}
        autoFocusButton="confirm"
        role="document"
        className={DocumentPropertiesCss.documentPropertiesDialog}
      >
        <DocPropertiesComponent formatMessage={formatMessage} activeElem={this.props.activeElem} />
      </Dialog>
    );
  }
}

export { DocumentPropertiesDialog };
